import a from"react";const r=({children:e,isOpen:o,dataHook:t})=>a.createElement("div",{"data-hook":t},o&&e);export{r as default};
//# sourceMappingURL=Collapse.js.map
